import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  formControl: {
    margin: '5px',
    width: '100%',
  },
  containerCard: {
    display: 'flex',
    marginInline: 30,
  }
}));

export default useStyles;
